// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { Fragment } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { isDefined } from "@clipboard-health/util-ts";

const Label = styled.label`
  margin-right: 10px;
`;

const Value = styled.span`
  margin-right: 8px;
`;

const InfoIcon = styled(InfoCircleOutlined)`
  color: rgba(0, 0, 0, 0.45);
`;

const TOOLTIP_TEXT =
  "This value is synchronized from Salesforce. To change it, update the workplace's Billing Rep in Salesforce.";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'facility' implicitly has an 'any' type.
function BillingSpecialistDisplay({ facility, admins }) {
  const { billingSpecialist } = facility;
  const billingSpecialistAdmin =
    isDefined(billingSpecialist) && admins.length > 0
      ? // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'admin' implicitly has an 'any' type.
        admins.find((admin) => admin._id === billingSpecialist)
      : undefined;

  return (
    <Fragment>
      <Label>Billing Specialist</Label>
      <Value>{billingSpecialistAdmin?.email ?? "-"}</Value>
      <Tooltip title={TOOLTIP_TEXT}>
        <InfoIcon />
      </Tooltip>
    </Fragment>
  );
}

export default BillingSpecialistDisplay;
